<template>
  <v-btn icon :title="title" @click="onClick" v-bind="$attrs">
    <v-icon color="primary">mdi-file-download-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'DownloadIconButton',
  props: {
    title: {
      default () {
        return this.$t('general.download');
      }
    }
  },
  methods: {
    onClick () {
      this.$emit('click');
    }
  }
}
</script>
